import React, { useState, useRef, useEffect } from "react";
import { Outlet } from "react-router-dom";
import ProfileSidebar from "../../components/Profile/ProfileSidebar/ProfileSidebar";
import { LuMenu } from "react-icons/lu";
import { FaArrowLeft } from "react-icons/fa";

function CustomerProfile() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const sidebarRef = useRef(null);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Close menu when clicking outside the sidebar
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (isMenuOpen && sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isMenuOpen]);

  return (
    <div className="flex flex-col lg:flex-row h-full">
      {/* Menu icon for small screens */}
      
      <button
        className="absolute top-4 left-4 z-50 p-2 bg-gray-200 rounded-md md:hidden"
        onClick={toggleMenu}
      >
        <LuMenu size={24} />
       
      </button>

      {/* Floating Sidebar for small screens */}
      <div
        ref={sidebarRef}
        className={`absolute top-0 left-0 z-40 w-3/4 h-full bg-white shadow-lg p-4 md:hidden 
          transition-transform duration-300 ease-in-out overflow-y-auto max-h-screen 
          ${isMenuOpen ? "transform translate-x-0" : "transform -translate-x-full"}`}
      >
       
        <ProfileSidebar />
      </div>

      <div
        className="flex-1 bg-cover bg-center"
        style={{
          backgroundImage: "url('/images/profile/BImage.png')",
        }}
      >
       

        <div className="flex w-full p-4 lg:p-10">
          {/* Sidebar for medium and larger screens */}
          <div className="w-4/1 hidden md:block bg-white rounded-2xl p-4 overflow-y-auto max-h-screen">
            <ProfileSidebar />
          </div>

          {/* Main Content */}
          <div className="w-4/3 ms-2 flex flex-1 flex-col">
            <div className="mt-2 flex-1 gap-2 lg:pb-6 lg:pl-6 lg:pr-6 overflow-y-auto bg-white rounded-2xl max-h-screen">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CustomerProfile;
